import { useState, useEffect } from 'react';

import { useLocation, useNavigate } from "react-router-dom";
// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { ModuloState, setModulo } from '../../store/slices/modulo/moduloSlice';
import { CursoState } from "../../store/slices/curso";
// LaTeX
import Latex from 'react-latex-next';
// mui components
import Divider from "@mui/material/Divider";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from "@mui/material/ListItemButton";
// mui icons
import PersonIcon from '@mui/icons-material/Person';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AddIcon from '@mui/icons-material/Add';
// componentes propios
import MenuModulos from "./MenuModulos";
import CrearModulo from "./CrearModulo";
import EditarModulo from "./EditarModulo";
import EliminarModulo from "./EliminarModulo";


type Props = {
    curso: CursoState
    modulos: Array<ModuloState>
}

const SidebarEdicion = ({ curso, modulos }: Props) => {

    const dispatch = useDispatch<AppDispatch>();

    const { usuario } = useSelector((state: RootState) => state.usuario);
    const { modulo } = useSelector((state: RootState) => state.modulo);

    const navigate = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
        navigate(`/curso/${curso?.sigla}/${modulo.modulo}`);
    }, [navigate, curso, modulo])
    
    
    const handleRoute = (modulo: ModuloState) => {
        // console.log(modulo)
        dispatch(setModulo(modulo))
    }

    // Crear Modulo
    const [openCrear, setOpenCrear] = useState(false);

    const handleClickOpenCrear = () => {
        setOpenCrear(true);
    };

    // Eliminar Modulo
    const [openEliminar, setOpenEliminar] = useState(false);

    // Editar Modulo
    const [openEditar, setOpenEditar] = useState(false);

    return (
        <>

            {
                openCrear && <CrearModulo open={openCrear} setOpen={setOpenCrear}/>
            }

            {
                openEditar && <EditarModulo open={openEditar} setOpen={setOpenEditar}/>
            }

            {
                openEliminar && <EliminarModulo open={openEliminar} setOpen={setOpenEliminar}/>
            }

            <List sx={{px: 1, position: 'relative', bottom: 0, backgroundColor: 'black'}}>
                <ListItem 
                    sx={{color: 'white', cursor: 'pointer'}} 
                    onClick={() => navigate('/inicio')}
                >
                    <ListItemIcon sx={{color: 'white'}}>
                        <AccountBalanceIcon/>
                    </ListItemIcon>
                    {/* <ListItemText primary={`${curso.sigla}`} /> */}
                    <ListItemText primary='CURSO' />
                </ListItem>
            </List>
            <div className="sidebar-edicion">
                <Divider sx={{color: 'white', p: 0, m: 0}} />

                <List sx={{px: 1}}>
                    <ListItem 
                        disablePadding
                        className='listItem'
                        sx={{
                            width: 220,
                            borderRadius: '5px',
                            marginBottom: '0.5em',
                            marginTop: '0.5em',
                            transition: '0.3s linear all',
                            color: 'white',
                            backgroundColor: 'rgba(255, 255, 255, 0.3)',
                            cursor: 'pointer',
                            '&:hover': {
                                borderRadius: '5px',
                                marginBottom: '0.5em',
                                marginTop: '0.5em',
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                color: 'white',
                                cursor: 'pointer',
                                transition: '0.3s linear all',
                            },
                        }}
                        onClick={handleClickOpenCrear}
                    >
                        <ListItemButton 
                            sx={{borderRadius: '5px'}}
                            role={undefined} 
                            // onClick={() => handleRoute(item)}
                        >
                            <ListItemIcon sx={{color: 'white'}}>
                                <AddIcon />
                            </ListItemIcon>
                            <ListItemText  primary='Crear Módulo' />
                        </ListItemButton>
                    </ListItem>

                    <ListItem 
                        disablePadding
                        className='listItem'
                        sx={`/curso/${curso?.sigla}/${0}` !== pathname ? {
                                width: '100%',
                                borderRadius: '5px',
                                marginBottom: '0.5em',
                                marginTop: '0.5em',
                                transition: '0.3s linear all',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'rgba(24, 62, 138, 0.4)',
                                    color: 'white',
                                    transition: '0.3s linear all'
                                },
                            } : {
                                width: '100%',
                                borderRadius: '5px',
                                marginBottom: '0.5em',
                                marginTop: '0.5em',
                                backgroundColor: 'rgb(24, 62, 138)',
                                color: 'white',
                                cursor: 'inherit',
                                transition: '0.3s linear all',
                                '&:hover': {
                                    width: '100%',
                                    borderRadius: '5px',
                                    marginBottom: '0.5em',
                                    marginTop: '0.5em',
                                    backgroundColor: 'rgb(24, 62, 138)',
                                    color: 'white',
                                    cursor: 'inherit',
                                    transition: '0.3s linear all',
                                },
                            }
                        }
                    >
                        <ListItemButton 
                            sx={{borderRadius: '5px'}}
                            role={undefined} 
                            onClick={() => handleRoute({cid: '', mid: '',modulo: 0,nombre: 'Noticias'})}
                        >
                            <ListItemIcon sx={{color: 'white'}}>
                                <i className="fa-solid fa-newspaper"></i>
                            </ListItemIcon>
                            <ListItemText  primary='Noticias' />
                        </ListItemButton>
                    </ListItem>

                    {
                        modulos.map(item => {
                            const { mid, modulo, nombre } = item;
                            return (
                                <ListItem 
                                    key={mid}
                                    secondaryAction={
                                        <MenuModulos
                                            modulo={item} 
                                            mid={mid}
                                            openEditar={openEditar} 
                                            setOpenEditar={setOpenEditar}
                                            openEliminar={openEliminar} 
                                            setOpenEliminar={setOpenEliminar}
                                        />
                                    }
                                    disablePadding
                                    className='listItem'
                                    sx={`/curso/${curso?.sigla}/${modulo}` !== pathname ? {
                                            width: '100%',
                                            borderRadius: '5px',
                                            marginBottom: '0.5em',
                                            marginTop: '0.5em',
                                            transition: '0.3s linear all',
                                            color: 'white',
                                            '&:hover': {
                                                backgroundColor: 'rgba(24, 62, 138, 0.4)',
                                                color: 'white',
                                                transition: '0.3s linear all'
                                            },
                                        } : {
                                            width: '100%',
                                            borderRadius: '5px',
                                            marginBottom: '0.5em',
                                            marginTop: '0.5em',
                                            backgroundColor: 'rgb(24, 62, 138)',
                                            color: 'white',
                                            cursor: 'inherit',
                                            transition: '0.3s linear all',
                                            '&:hover': {
                                                width: '100%',
                                                borderRadius: '5px',
                                                marginBottom: '0.5em',
                                                marginTop: '0.5em',
                                                backgroundColor: 'rgb(24, 62, 138)',
                                                color: 'white',
                                                cursor: 'inherit',
                                                transition: '0.3s linear all',
                                            },
                                        }
                                    }
                                >
                                    <ListItemButton 
                                        sx={{borderRadius: '5px'}}
                                        role={undefined} 
                                        onClick={() => handleRoute(item)}
                                    >
                                        <ListItemIcon sx={{color: 'white'}}>
                                            {
                                                modulo === 0 ? 
                                                <i className="fa-solid fa-newspaper"></i> :
                                                <div 
                                                    style={{ 
                                                        background: 'white', 
                                                        color: 'black', 
                                                        borderRadius: '5px', 
                                                        width: '23px', 
                                                        height: '23px', 
                                                        textAlign: 'center', 
                                                        fontWeight: 'bold', 
                                                        verticalAlign: 'middle'
                                                    }}
                                                >
                                                    {modulo}
                                                </div>
                                            }
                                            
                                        </ListItemIcon>
                                        <ListItemText  primary={<Latex>{nombre}</Latex>} />
                                    </ListItemButton>
                                </ListItem>
                            )
                        })
                    }
                </List>
            </div>
            <List sx={{px: 1, position: 'relative', bottom: 0, backgroundColor: 'black'}}>
                <ListItem 
                    sx={{
                        width: 220,
                        borderRadius: '5px',
                        marginBottom: '0.5em',
                        marginTop: '0.5em',
                        transition: '0.3s linear all',
                        color: 'white',
                        backgroundColor: 'rgba(255, 255, 255, 0.4)',
                    }}
                >
                    <ListItemIcon sx={{color: 'white'}}>
                        <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary={`${usuario.nombre} ${usuario.apellido}`} />
                </ListItem>
            </List>
        </>
    )
}

export default SidebarEdicion


// // redux
// import { useLocation, useNavigate } from "react-router-dom";
// // mui components
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// // logo MAT1000
// // import logoMAT from '../../img/Logo_PIMU_Color_Small.png';
// import { useDispatch, useSelector } from 'react-redux';
// import { AppDispatch, RootState } from '../../store';
// import { setRuta } from "../../store/slices/ruta";
// import { ModuloState, setModulo } from '../../store/slices/modulo/moduloSlice';

// import PersonIcon from '@mui/icons-material/Person';
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

// import AddIcon from '@mui/icons-material/Add';
// import MenuIcon from '@mui/icons-material/Menu';

// import CommentIcon from '@mui/icons-material/Comment';
// import { Checkbox, Divider, IconButton, ListItemButton } from "@mui/material";
// import MenuModulos from "./MenuModulos";
// import CrearModulo from "./CrearModulo";
// import { useState } from "react";
// import EditarModulo from "./EditarModulo";


// type Props = {
//     curso: string
//     routes: any
//     modulos: Array<ModuloState>
// }

// type Ruta = {
//     id: number | 0,
//     title: string | '',
//     name: string | '', 
//     modulo: string  | '',
//     href: string | '', 
//     icon: any | '',
// }

// const SidebarEdicion = ({ curso, routes, modulos }: Props) => {

//     const dispatch = useDispatch<AppDispatch>();

//     const { usuario } = useSelector((state: RootState) => state.usuario);

//     const navigate = useNavigate();
//     const { pathname } = useLocation();
    
//     const handleRoute = (route: Ruta) => {
//         // console.log(route)
//         navigate(route.href);
//         const modulo = modulos.find(item => item.modulo === Number(route.modulo))
//         dispatch(setModulo(modulo))
//         dispatch(setRuta(route.modulo))
//     }

//     // Crear Modulo
//     const [openCrear, setOpenCrear] = useState(false);

//     const handleClickOpenCrear = () => {
//         setOpenCrear(true);
//     };

//     // Editar Modulo
//     const [openEditar, setOpenEditar] = useState(false);

//     const handleClickOpenEditar = () => {
//         setOpenEditar(true);
//     };



//     return (
//     <div className="sidebar-edicion">
        
//         {
//             openCrear && <CrearModulo open={openCrear} setOpen={setOpenCrear}/>
//         }

//         {
//             openEditar && <EditarModulo open={openEditar} setOpen={setOpenEditar}/>
//         }
        
//         <List>
//             <ListItem 
//                 sx={{color: 'white', cursor: 'pointer'}} 
//                 onClick={() => navigate('/inicio')}
//             >
//                 <ListItemIcon sx={{color: 'white'}}>
//                     <AccountBalanceIcon/>
//                 </ListItemIcon>
//                 <ListItemText primary={`${curso}`} />
//             </ListItem>
            
//         </List>

//         <Divider sx={{color: 'white', p: 0, m: 0}} />

//         <List sx={{px: 1}}>
//             <ListItem 
//                 disablePadding
//                 // secondaryAction={
//                 //     <CrearModulo />
//                 // }
//                 sx={{
//                     width: 220,
//                     borderRadius: '5px',
//                     marginBottom: '0.5em',
//                     marginTop: '0.5em',
//                     transition: '0.3s linear all',
//                     color: 'white',
//                     backgroundColor: 'rgba(255, 255, 255, 0.3)',
//                     cursor: 'pointer',
//                     '&:hover': {
//                         borderRadius: '5px',
//                         marginBottom: '0.5em',
//                         marginTop: '0.5em',
//                         backgroundColor: 'rgba(255, 255, 255, 0.5)',
//                         color: 'white',
//                         cursor: 'pointer',
//                         transition: '0.3s linear all',
//                     },
//                 }}
//                 onClick={handleClickOpenCrear}
//             >
//                 <ListItemButton 
//                             role={undefined} 
//                             // onClick={() => handleRoute(route)}
//                             dense
//                         >
                            
//                             <ListItemIcon sx={{color: 'white'}}>
//                                 <AddIcon />
//                             </ListItemIcon>
//                 <ListItemText primary='Agregar Módulo' />
//                         </ListItemButton>

                
//             </ListItem>
//         </List>


//         <List 
//             // sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
//             sx={{px: 1}}
//         >
//             {
//                 routes.map((route: Ruta) => {
//                     const {id, name, icon, modulo, title} = route;
//                     const labelId = `checkbox-list-label-${id}`;
//                 return (
//                     <ListItem
//                         key={id}
//                         secondaryAction={
//                             <MenuModulos 
//                                 modulo={modulo} 
//                                 mid={id}
//                                 openEditar={openEditar} 
//                                 setOpenEditar={setOpenEditar}
//                             />
//                         }
//                         disablePadding
//                         className='listItem'
//                             sx={ route?.href !== pathname ? {
//                                     width: '100%',
//                                     borderRadius: '5px',
//                                     marginBottom: '0.5em',
//                                     marginTop: '0.5em',
//                                     transition: '0.3s linear all',
//                                     color: 'white',
//                                     '&:hover': {
//                                         backgroundColor: 'rgba(24, 62, 138, 0.4)',
//                                         color: 'white',
//                                         transition: '0.3s linear all'
//                                     },
//                                 } : {
//                                     width: '100%',
//                                     borderRadius: '5px',
//                                     marginBottom: '0.5em',
//                                     marginTop: '0.5em',
//                                     backgroundColor: 'rgb(24, 62, 138)',
//                                     color: 'white',
//                                     cursor: 'inherit',
//                                     transition: '0.3s linear all',
//                                     '&:hover': {
//                                         width: '100%',
//                                         borderRadius: '5px',
//                                         marginBottom: '0.5em',
//                                         marginTop: '0.5em',
//                                         backgroundColor: 'rgb(24, 62, 138)',
//                                         color: 'white',
//                                         cursor: 'inherit',
//                                         transition: '0.3s linear all',
//                                     },
//                                 }
//                             }
//                     >
//                         <ListItemButton 
//                             role={undefined} 
//                             onClick={() => handleRoute(route)}
//                             // dense
//                         >
//                             <ListItemIcon sx={{color: 'white'}}>
//                                 {icon}
//                             </ListItemIcon>
//                             <ListItemText  primary={name} />
//                         </ListItemButton>
//                     </ListItem>
//                 )
//                 })
//             }
//         </List>
//     </div>
//   )
// }

// export default SidebarEdicion